<ngx-loading [show]="loading"></ngx-loading>
<div class='col-md-12 col-sm-12 col-xs-12'>
  <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 reviewbottom">
      <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
          <span><img [src]="business_logo" class="img-responsive" *ngIf="business_logo != null">
          <span class="bus_name_review">{{business_name}}</span></span>

      </div>
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
          <p>{{campaign_content}}</p>
      </div>


  </div>
</div>
<footer>
    <div class="col-md-12 col-col-sm-12 col-xs-12">
      <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
          <p>Powered by</p>
        <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=review_invite" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
      </div>
    </div>
</footer>



